var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confidentiality-restriction"},[_c('img',{attrs:{"src":require('/src/assets/img/odc/cr.png')}}),_c('a',{staticClass:"down",staticStyle:{},attrs:{"href":require('/src/assets/download.ttf'),"download":"J&F软件研发保密制度.pdf"}},[_vm._v("download")])])
}
var staticRenderFns = []

export { render, staticRenderFns }